import { render, staticRenderFns } from "./transportation_list.vue?vue&type=template&id=cf3e71e0"
import script from "./transportation_list.vue?vue&type=script&lang=js"
export * from "./transportation_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports